var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchivoIntegracionExpediente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m400 64v168h-168l-104-104h-64v-64c.027344-8.824219 7.175781-15.972656 16-16h304c8.824219.027344 15.972656 7.175781 16 16zm0 0",
    fill: "#96c8ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m464 232v216c-.027344 8.824219-7.175781 15.972656-16 16h-432c-8.824219-.027344-15.9726562-7.175781-16-16v-320h128l104 104zm0 0",
    fill: "#ffde55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 232h-24l-104-104h24zm0 0",
    fill: "#78b9eb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m464 120v112h-64v-128h48c8.824219.027344 15.972656 7.175781 16 16zm0 0",
    fill: "#ff9811"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m304 48v80l24-32 24 32v-80zm0 0",
    fill: "#ff5023"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m334 104 2 2.640625-16 21.359375v-21.359375l2-2.640625 6-8zm0 0",
    fill: "#78b9eb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m368 48v80l-16-21.359375v-58.640625zm0 0",
    fill: "#78b9eb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m176 48h-96c-8.824219.027344-15.972656 7.175781-16 16v64h-64v-112c.0273438-8.824219 7.175781-15.9726562 16-16h112zm0 0",
    fill: "#ff9811"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m32 336h128v96h-128zm0 0",
    fill: "#00ccb3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m400 104h16v128h-16zm0 0",
    fill: "#ee8700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m160 336h16v96h-16zm0 0",
    fill: "#ffd422"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5aaae7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168 88h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 88h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 120h112v16h-112zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 152h144v16h-144zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 184h112v16h-112zm0 0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m56 360h16v16h-16zm0 0",
    fill: "#00b39d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m88 360h48v16h-48zm0 0",
    fill: "#00b39d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m56 392h80v16h-80zm0 0",
    fill: "#00b39d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivoIntegracionExpediente);
export default __webpack_public_path__ + "static/media/archivo_integracion_expediente.70e02a168361c8d19ab3b20cdaad208f.svg";
export { ForwardRef as ReactComponent };